import React from "react";
import bgImgLeft from "../../../../Assets/Images/Image [__wab_img] 1.png";
import bgImgRight from "../../../../Assets/Images/Image [__wab_img] 2.png";
import "../AllBanner/technologiesBanner.css";

const BannerOne = () => {
  return (
    <div
      className="tech-web-banner"
      style={{
        background: " #0b4f5d",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Images */}
      <div
        className="d-flex justify-content-between align-items-center px-3 px-md-5"
        style={{
          zIndex: "0",
          position: "relative",
        }}
      >
        <div
          className="" // Hide left image on mobile
          style={{ flex: "1", textAlign: "left" }}
        >
          <img
            src={bgImgLeft}
            alt="bgImgLeft"
            className="img-fluid"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>

        <div
          className="d-none d-md-block" // Hide right image on mobile
          style={{ flex: "1", textAlign: "right" }}
        >
          <img
            src={bgImgRight}
            alt="bgImgRight"
            className="img-fluid"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
      </div>

      {/* Text Section */}
      <div
        className="container text-center py-5"
        style={{
          position: "absolute",
          zIndex: "1",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "white",
          width: "100%",
          maxWidth: "900px",
          padding: "0 15px",
        }}
      >
        <h2
          className="fw-semibold database-text d-none d-md-block"
          style={{
            fontSize: "",
          }}
        ></h2>
        <h2
          className="fw-semibold database-heading"
          style={{
            fontSize: "",
          }}
        >
          Technologies Chosen From Real Project Experience
        </h2>
        <p
          className="mt-3 database-text "
          style={{
            lineHeight: "1.8",
          }}
        >
          The technologies and frameworks we use are informed by years of
          building, maintaining and fixing real systems. Each choice is what
          holds up under actual usage, changing requirements and long-term
          ownership.
        </p>
      </div>
    </div>
  );
};

export default BannerOne;
